import { render, staticRenderFns } from "./SwatchColorPicker.vue?vue&type=template&id=a30aa87c"
import script from "./SwatchColorPicker.vue?vue&type=script&lang=js"
export * from "./SwatchColorPicker.vue?vue&type=script&lang=js"
import style0 from "./SwatchColorPicker.vue?vue&type=style&index=0&id=a30aa87c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports